import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../redux";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { expanderConstants } from "../../../redux/models/constants/expanders";
import ExpanderWithSubtitle from "../ExpanderWithSubtitle";
import HomeItem from "./HomeItem";
import { ModeEnum } from "../../enums/modeEnum";
import { IStoreItem } from "../../../interfaces/IStoredItem";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { ExpanderStateEnum } from "../../enums/expanderStateEnum";
import { IDialogContentProps } from "@fluentui/react";
import generalModule from "../../../../../utilities/GeneralModule";
import { getSuggestedItems } from "../../../redux/modules/suggestedItems";

const mapDispatchToProps = {
  getSuggestedItems
};

const mapStateToProps = (state: RootState) => {
  return {
    suggested: state.suggested,
    accountId: state.user?.account?.accountId,
    username: state.user?.account?.username
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface SuggestedItemsProps extends PropsFromRedux {
  mode: ModeEnum;
  openFileOptions: (item: IStoreItem, isSuggestedList: boolean) => void;
  openFolderOptions: (item: IStoreItem, isRecentList: boolean, isSuggestedList: boolean) => void;
  showLicenseDialog: () => void;
  saveToOneDrive: (
    folderName: string,
    fromLocationItemCurrentDirectory?: IPageSettings,
    savingLocationDirectory?: string,
    locationBeforeSaving?: IPageSettings[]
  ) => Promise<void>;
  setLicenseMessageContent: (content: IDialogContentProps) => void;
}

const SuggestedItems: React.FunctionComponent<SuggestedItemsProps> = ({
  suggested,
  mode,
  openFileOptions,
  openFolderOptions,
  showLicenseDialog,
  saveToOneDrive,
  accountId,
  username,
  getSuggestedItems,
  setLicenseMessageContent
}: SuggestedItemsProps) => {
  const languageStrings = React.useContext(LanguageContext);
  const [expanderState, setExpanderState] = React.useState<ExpanderStateEnum>(ExpanderStateEnum.unset);

  const canToggle = React.useRef<boolean>(generalModule.isInConentMangerMode() ? false : true); //Side menu - toggle/button

  React.useEffect(() => {
    const sender: string = mode !== ModeEnum.mailSend
      ? Office?.context?.mailbox?.item?.from?.emailAddress
      : username;

    if (sender && accountId) {
      (async () => {
        const suggestedCount = await getSuggestedItems(accountId, sender);
        if (suggestedCount > 0) {
          setExpanderState(ExpanderStateEnum.expanded);
        }
      })();
    }
  }, [Office?.context?.mailbox?.item?.from?.emailAddress, mode, accountId, username]);

  const items: JSX.Element[] = suggested.suggestedItems && suggested.suggestedItems.map((item, index) => {
    return (
      <HomeItem
        key={index}
        homeItem={item}
        mode={mode}
        isRecentList={false}
        isSuggestedList={true}
        openFileOptions={openFileOptions}
        openFolderOptions={openFolderOptions}
        showLicenseDialog={showLicenseDialog}
        saveToOneDrive={saveToOneDrive}
        setLicenseMessageContent={setLicenseMessageContent}
      />
    );
  });

  return (
    <ExpanderWithSubtitle
      iconName="FavoriteList"
      items={!canToggle.current ? [] : items?.length > 0 ? items : suggested.isSuggestedItemsLoading ? [<Spinner key={0} />] : [<p className="xb-empty-location-message centerText" key="0">{languageStrings.SuggestedItemsShownHere}</p>]}
      title={languageStrings.Suggestions}
      expanderNameToToggle={expanderConstants.home.suggestions}
      hasShowMoreButton={true}
      expanderState={expanderState}
      canToggle={canToggle.current}
    />
  );
};

export default connector(SuggestedItems);
